import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import FontSizes from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
import FontStyles from '@polestar/component-warehouse-react/tokens/font-styles/FontStyles';
import FontWeights from '@polestar/component-warehouse-react/tokens/font-weights/FontWeights';
import Fonts from '@polestar/component-warehouse-react/tokens/fonts/Fonts';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import LineHeights from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const size = {
    medium: {
        width: Spacings.xLarge,
        height: Spacings.xLarge,
        // this is needed when a number-badge is used with an IconButton
        spacing: Spacings.xxSmall,
    },
    large: {
        width: Spacings.xxLarge,
        height: Spacings.xxLarge,
        // this is needed when a number-badge is used with an IconButton
        spacing: Spacings.xSmall,
    },
    xLarge: {
        width: Spacings.xxLarge,
        height: Spacings.xxLarge,
        // this is needed when a number-badge is used with an IconButton
        spacing: Spacings.xxSmall,
    },
};
const fontProps = {
    fontSize: FontSizes.body,
    lineHeight: LineHeights.small,
    fontWeight: FontWeights.regular,
    fontFamily: Fonts.polestarUnica,
    fontStyle: FontStyles.normal,
};
const IconButtonTheme = {
    iconButton: {
        light: {
            transparent: {
                ...fontProps,
                backgroundColor: Colors.transparent,
                states: {
                    enabled: {
                        color: withOpacity(Colors.black, Opacities.medium),
                    },
                    disabled: {
                        color: withOpacity(Colors.black, Opacities.low),
                    },
                    hover: {
                        color: Colors.black,
                    },
                    active: {
                        color: withOpacity(Colors.black, Opacities.medium),
                    },
                },
                sizes: size,
            },
            white: {
                ...fontProps,
                backgroundColor: Colors.white,
                states: {
                    enabled: {
                        color: withOpacity(Colors.black, Opacities.medium),
                    },
                    disabled: {
                        color: withOpacity(Colors.black, Opacities.low),
                    },
                    hover: {
                        color: Colors.black,
                    },
                    active: {
                        color: withOpacity(Colors.black, Opacities.medium),
                    },
                },
                sizes: size,
            },
            black: {
                ...fontProps,
                backgroundColor: Colors.black,
                states: {
                    enabled: {
                        color: withOpacity(Colors.white, Opacities.medium),
                    },
                    disabled: {
                        color: withOpacity(Colors.white, Opacities.low),
                    },
                    hover: {
                        color: Colors.white,
                    },
                    active: {
                        color: withOpacity(Colors.white, Opacities.medium),
                    },
                },
                sizes: size,
            },
            followTheme: {
                ...fontProps,
                backgroundColor: Colors.white,
                states: {
                    enabled: {
                        color: withOpacity(Colors.black, Opacities.medium),
                    },
                    disabled: {
                        color: withOpacity(Colors.black, Opacities.low),
                    },
                    hover: {
                        color: Colors.black,
                    },
                    active: {
                        color: withOpacity(Colors.black, Opacities.medium),
                    },
                },
                sizes: size,
            },
        },
        dark: {
            transparent: {
                ...fontProps,
                backgroundColor: Colors.transparent,
                states: {
                    enabled: {
                        color: withOpacity(Colors.white, Opacities.medium),
                    },
                    disabled: {
                        color: withOpacity(Colors.white, Opacities.low),
                    },
                    hover: {
                        color: Colors.white,
                    },
                    active: {
                        color: withOpacity(Colors.white, Opacities.medium),
                    },
                },
                sizes: size,
            },
            followTheme: {
                ...fontProps,
                backgroundColor: Colors.black,
                states: {
                    enabled: {
                        color: withOpacity(Colors.white, Opacities.medium),
                    },
                    disabled: {
                        color: withOpacity(Colors.white, Opacities.low),
                    },
                    hover: {
                        color: Colors.white,
                    },
                    active: {
                        color: withOpacity(Colors.white, Opacities.medium),
                    },
                },
                sizes: size,
            },
        },
    },
};
export default IconButtonTheme;
